export default __webpack_public_path__ + "static/media/authyIcon.1ac918aa.svg";